module.exports = __webpack_public_path__ + "static/media/Serie-LUP.3255c627.pdf";